import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuthContext } from "../src/context/AuthContext.tsx"; 
import { ProgressSpinner } from "primereact/progressspinner";
import { useMediaQuery } from '@mui/material';
import Loading from "../src/pages/LoginPage/Loading.tsx";

const ProtectedRoute: React.FC = () => {
    const { auth, isLoading } = useAuthContext(); 
    const isSmallScreen = useMediaQuery('(max-width:1200px)');

    if (isLoading) {
        // return (
        //     <div
        //         style={{
        //             display: 'flex',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //             height: '100vh',
        //             backgroundColor: '#fff',
        //         }}
        //     >
        //         <ProgressSpinner style={{ width: '65px', height: '65px' }} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
        //     </div>
        // );
        return (
            isSmallScreen ?
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh'
                    }}
                >
                    <ProgressSpinner style={{ width: '65px', height: '65px' }} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
                :
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',

                    }}
                >
                    <Loading />
                </div>
        );
    }

    // Redirect to the login page if the user is not authenticated
    return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
